import live from './live'
import speed from './speed'
import trajectori from './trajectori'

export default {
  name: 'Location',
  path: 'location',
  meta: {
    label: 'trajectory',
    auth: 'location'
  },
  component: {
    name: 'Location',
    render(c) {
      return c('router-view')
    }
  },
  children: [live, speed, trajectori]
}
